
///
/// Disabled Elements
///
/// Add a tabindex of -1 to all disabled elements
/// so that focus cannot be passed to the element 

window.ClearUmbFormFields = function () {

    var umbForm = document.querySelector('.umbraco-forms-page');

    if (umbForm != null) {

        var frm = document.querySelector('.umbraco-forms-form form');

        if (frm != null) {
            
            frm.reset();
        }

    } else {
        //console.log('No form found');
    }
}

function disableUmbFormSubmitButton() {

    var btn = document.querySelector('.umbraco-forms-form form button[type=submit].btn--primary');

    // console.log(btn);

    if (btn != null) {
        btn.setAttribute('disabled', 'disabled');
        //console.log('submit button found');
    } else {
        //console.log('no submit button found');
    }
}

window.addEventListener('popstate', function (event) {
    // Clear form fields when the user navigates back
    window.ClearUmbFormFields();
});
window.addEventListener("pageshow", () => {
    window.ClearUmbFormFields();
});